module.exports = __webpack_public_path__ + "static/img/banner.58a6eaa.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.gif
// module id = 221
// module chunks = 180